export const PARKING_SERVICE_ENDPOINTS = {
  cancelParkingVoucher: process.env.GATSBY_API_POST_CANCELED_PARKING_TICKETS ?? '',
  getOrder: process.env.GATSBY_API_POST_PARKING_TICKETS ?? '',
  getParkingLots: process.env.GATSBY_API_GET_PARKING_LOTS ?? '',
  getParkingPrice: process.env.GATSBY_API_POST_PARKING_PRICE ?? '',
} as const;
